<div class="d-flex flex-column">
	<input
		#addresstext
		pInputText
		type="text"
		autocomplete="street-address"
		name="name"
		[(ngModel)]="autocompleteInput"
		class="w-100"
		[placeholder]="placeholder"
	/>
	<span class="p-float-label mt-4">
		<input
			pInputText
			#addressStreet2Input
			name="addressStreet2Input"
			autocomplete="address-line2"
			type="text"
			[(ngModel)]="addressObject.suiteApt"
			class="w-100"
		/>
		<label for="addressStreet2Input">Suite/Apartment</label>
	</span>
	<button *ngIf="existingAddressValue" type="button" pButton pRipple icon="pi pi-refresh" styleClass="p-button-warn" (click)="resetAutoComplete()"></button>
</div>
